export default __webpack_public_path__ + "static/media/1153.1cf5207b.png";